
export const invoiceBulkPost = (i, doctype, AllocationInvoice) => {
    
    return {
      ...(AllocationInvoice && { AllocationInvoice: AllocationInvoice }), 
      InvoiceID: i.InvoiceID || i.CreditNoteID,
      DocType: doctype,
      IsSimplified: i.DocumentType? i.DocumentType === 'standard' ? false : true:null,
      Reporting: true,
      DocumentType: i.DocumentType,
      DocumentTypeConfirmed: i.DocumentTypeConfirmed,
      Contact: i.Contact,
      InvoiceNumber: i.InvoiceNumber || i.CreditNoteNumber
    };
  };

export const invoiceSDKPost = (i, doctype, invoiceType) => {

  const IsSimplified = invoiceType === 'standard' ? false : true

  return {
    ...i,
    IsSimplified: IsSimplified,
    Reporting: true,
    DocType: doctype,
    DocumentTypeConfirmed: i.DocumentTypeConfirmed,
  };
};

